import { GetLicenseDetailsAsync, LicenceTypes } from "../api/LicenceDetails";

let SUBMISSIONS_DOMAIN = "http://localhost:3001";
let OBJECTIONS_DOMAIN = "https://lema-int.edenireland.ie";
let RSS_URL_DOMAIN = "https://epawebapp.epa.ie";
let LEAP_RSS_URL_DOMAIN = "https://epawebapp.epa.ie";
let LEAP_BASE_URL = "http://localhost:3000";
let CIRCULAR_ECONOMY_BASE_URL = "http://localhost:3003";

export const GO_LIVE_DATE = "09/12/2025";

//https://leap-int.edenireland.ie/docs/rss/w0299-01.xml
switch (process.env.REACT_APP_EPA_ENV) {
  case "localhost":
    SUBMISSIONS_DOMAIN = "http://localhost:3001";
    RSS_URL_DOMAIN = "http://localhost:3001";
    LEAP_RSS_URL_DOMAIN = "https://leap-int.edenireland.ie";
    break;

  case "inttest":
    SUBMISSIONS_DOMAIN = "https://lema-int.epa.ie";
    RSS_URL_DOMAIN = "https://epawebapp-test.epa.ie";
    LEAP_RSS_URL_DOMAIN = "https://leap-int.edenireland.ie";
    OBJECTIONS_DOMAIN = "https://lema-int.edenireland.ie";
    LEAP_BASE_URL = "https://leap-int.edenireland.ie";
    CIRCULAR_ECONOMY_BASE_URL = "https://circulareconomy-int.edenireland.ie";
    break;

  case "bustest":
    SUBMISSIONS_DOMAIN = "https://lema-tst.epa.ie";
    RSS_URL_DOMAIN = "https://epawebapp-test.epa.ie";
    LEAP_RSS_URL_DOMAIN = "https://leap-tst.edenireland.ie";
    OBJECTIONS_DOMAIN = "https://lema-tst.edenireland.ie";
    LEAP_BASE_URL = "https://leap-tst.edenireland.ie";
    CIRCULAR_ECONOMY_BASE_URL = "https://circulareconomy-tst.edenireland.ie";
    break;

  case "staging":
    SUBMISSIONS_DOMAIN = "https://lema-stg.epa.ie";
    RSS_URL_DOMAIN = "https://epawebapp-test.epa.ie";
    LEAP_RSS_URL_DOMAIN = "https://leap-stg.epa.ie";
    OBJECTIONS_DOMAIN = "https://lema-stg.edenireland.ie";
    LEAP_BASE_URL = "https://leap-stg.epa.ie";
    CIRCULAR_ECONOMY_BASE_URL = "https://circulareconomy-stg.epa.ie";
    break;

  case "production":
    SUBMISSIONS_DOMAIN = "https://lema.epa.ie";
    RSS_URL_DOMAIN = "https://epawebapp.epa.ie";
    LEAP_RSS_URL_DOMAIN = "https://leap.epa.ie";
    OBJECTIONS_DOMAIN = "https://lema.edenireland.ie";
    LEAP_BASE_URL = "https://leap.epa.ie";
    CIRCULAR_ECONOMY_BASE_URL = "https://circulareconomy.epa.ie";

    break;
}

export const RSS_PREFIX = `${SUBMISSIONS_DOMAIN}/licences/lic_eDMS/rss`;
export const LEAP_RSS_PREFIX = `${LEAP_RSS_URL_DOMAIN}/docs/rss`;

export const ETS_BASE_URL = `${LEAP_BASE_URL}/ETS`;
export const ABSTRACTIONS_BASE_URL = `${LEAP_BASE_URL}/abstractions`;

export const GetLicenceVersionUrl = (
  licenceType: string,
  profileNo: string,
  licenceId: string,
  regNo: string
) => {
  switch (licenceType) {
    case LicenceTypes.ByProductNotification:
    case LicenceTypes.ByProductRegistration:
      return `${CIRCULAR_ECONOMY_BASE_URL}/notifier/${licenceId}`;

    case LicenceTypes.EoW:
      return `${CIRCULAR_ECONOMY_BASE_URL}/eow/${licenceId}`;

    case LicenceTypes.CoR:
      return `${CIRCULAR_ECONOMY_BASE_URL}/cor/${licenceId}`;

    case LicenceTypes.Abstraction:
      return `${LEAP_BASE_URL}/abstractions/${regNo}`;

    default:
      return `${LEAP_BASE_URL}/licence-profile/${profileNo}/versions/${licenceId}`;
  }
};

export const GetLicenceProfileUrl = (
  licenceType: string,
  profileNo: string,
  activeLicenceId: string,
  activeLicenceRegNo: string
) => {
  switch (licenceType) {
    case LicenceTypes.ByProductNotification:
    case LicenceTypes.ByProductRegistration:
    case LicenceTypes.EoW:
    case LicenceTypes.CoR:
    case LicenceTypes.Abstraction:
      return GetLicenceVersionUrl(
        licenceType,
        profileNo,
        activeLicenceId,
        activeLicenceRegNo
      );

    default:
      return `${LEAP_BASE_URL}/licence-profile/${profileNo}`;
  }
};

export const GetSubmissionUrl = (regNo: string) => {
  return `${SUBMISSIONS_DOMAIN}/Submissions/Submission.aspx?p1=${regNo}`;
};

export const GetMakeAnObjectionUrl = (regNo: string) => {
  return `${OBJECTIONS_DOMAIN}/Am/Objections/ObjectionDetails/ByRegNo/${regNo}`;
};

export const GetObservationUrl = (regNo: string) => {
  return `${SUBMISSIONS_DOMAIN}/Submissions/Observation.aspx?p1=${regNo}`;
};

export const GetLeapRssUrl = (regNo: string) => {
  return `${LEAP_RSS_URL_DOMAIN}/docs/rss/${regNo}.xml`;
};

export const GetRssUrl = (regNo: string) => {
  return `${RSS_URL_DOMAIN}/licences/lic_eDMS/rss/${regNo}.xml`;
};
